import {
    getCustomer,
    listCustomers
} from './queries';
import {
    createCustomer,
    deleteCustomer,
    updateCustomer,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Customer} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListCustomers = {
    listCustomers: { items: Customer[], nextToken?: string }
}

export type GetCustomer = {
    getCustomer: Customer
}

export type CreateCustomer = {
    createCustomer: Customer
}

export type UpdateCustomer = {
    updateCustomer: Customer
}

export type DeleteCustomer = {
    deleteCustomer: string
}

const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListCustomers>>({
                                                                           query: listCustomers,
                                                                           variables: {filter: filter, limit, nextToken},
                                                                       });
    return response.data?.listCustomers;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetCustomer>>({
                                                                         query: getCustomer,
                                                                         variables: {id: id},
                                                                     });
    return response.data?.getCustomer;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateCustomer>>({
                                                                            query: createCustomer,
                                                                            variables: {input: payload},
                                                                        });
    return response.data?.createCustomer;
};

export const update = async (_id: string, record: Customer) => {
    const payload = {...record} as Record<string, unknown>;
    delete payload.created;

    const response = await client.graphql<GraphQLQuery<UpdateCustomer>>({
                                                                            query: (updateCustomer),
                                                                            variables: {input: payload},
                                                                        });
    return response.data?.updateCustomer;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteCustomer>>({
                                                                            query: (deleteCustomer),
                                                                            variables: {input: {id: id}},
                                                                        });
    return response.data?.deleteCustomer;
};
